/**
 * Converts a given name to a series of initials
 * @param {String} fullname A full name to convert to initials
 * @param {Number} length Requested length for initials
 * @returns {String} The initialized version of the name
 */
export default function (fullname, length) {
  if (fullname) {
    const initials = fullname.split(/[\s]+/g).map(name => name[0]).join('');

    return length !== 2 || initials.length === 1 ? initials.substr(0, 3).toUpperCase()
      : initials.substr(0, 1).concat(initials.substr(initials.length - 1)).toUpperCase();
  }
  return '';
}
